module.exports = __webpack_public_path__ + "england.svg?942f27f1f6c9f82f2abf00988dcda901";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/england.svg
// module id = 157
// module chunks = 10